import { useCallback } from 'react';
import { demeterApi } from '../../../Apis/Apis';
import { DemeterSymbolModel } from '../../../Generated/Raven-Demeter';
import CacheKeys from '../../Services/Cache/CacheKeys';
import useCacheOrApi from './useCacheOrApiHook';

const useSymbolsApi = (showExpiredContracts?: boolean): DemeterSymbolModel[] | undefined => {
    const apiCallback = useCallback(
        () => (showExpiredContracts ? demeterApi.listDemeterSymbols(true) : demeterApi.listDemeterSymbols()),
        [showExpiredContracts],
    );

    const cacheKey = showExpiredContracts ? CacheKeys.ListDemeterSymbolsWithExpiredContracts : CacheKeys.ListDemeterSymbols;

    const [, , listDemeterSymbolsResponse] = useCacheOrApi(cacheKey, apiCallback);

    return listDemeterSymbolsResponse?.rows ?? undefined;
};

export default useSymbolsApi;
